<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button, toast } from '@Shelly/shelly-design-system';
	//Helpers
	import { callBluTRV, isBluTRVCalibrated } from 'src/helpers/virtual_helpers/blutrv_helpers';
	//Types
	import type { Device } from 'src/types/Device';

	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device: Device;

	let waitForResponse = false;

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: calibrate,
				loading: waitForResponse,
				disabled: waitForResponse,
				label: $format('button_start_calibration', { default: '"Start calibration"' }),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});

	const calibrate = async (): Promise<void> => {
		waitForResponse = true;
		await callBluTRV(device, 'Trv.Calibrate', { id: 0 });
		waitForResponse = false;
	};
	const isNotCalibrated: boolean = !isBluTRVCalibrated(device);
	let checkingCalibrated = isNotCalibrated;

	$: if (checkingCalibrated && isBluTRVCalibrated(device)) {
		checkingCalibrated = false;
		toast.open({
			type: 'success',
			title: $format('text_blu_trv_calibrate_successful', {
				default: 'Calibration is successful',
			}),
		});
	}
</script>

{#if !$showNewLayout}
	<Button
		size="m"
		width="full"
		loading={waitForResponse}
		disabled={waitForResponse}
		on:click={calibrate}
	>
		{$format('button_start_calibration', {
			default: '"Start calibration"',
		})}
	</Button>
{/if}
